import React, { Component } from "react";
import { logoutUser } from "../../actions/authAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Spinner from "react-spinkit";
import Avatar from "react-avatar";
import {
  Navbar,
  NavbarBrand,
  NavItem,
  Badge,
  NavbarToggler,
  Collapse,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import { UPDATE_DATA } from "../../actions/types";
import { Popup } from "semantic-ui-react";
import { mqttConnectionInit, getPrescriptions, getPrescriptionByStatus } from "../../actions/mqttAction";
import store from "../..";
class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.props.mqttConnectionInit();

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  logout(e) {
    e.preventDefault();
    this.props.logoutUser();
  }
  changeBranch = branch => {
    localStorage.branch = "" + branch;
    window.location.reload(false);
  };
  updateData() {
    //store.dispatch({type: UPDATE_DATA, payload: true});
    let orgId;
    if (this.props.auth.user.orgId) orgId = this.props.auth.user.orgId;
    else orgId = 1;
    let branchName;
    localStorage.branch
      ? (branchName = localStorage.branch)
      : (branchName = "Chama");
    if (window.location.pathname === '/store') {
      this.props.getPrescriptionByStatus(orgId, branchName, 'CounsellingPending')
    } else {
      this.props.getPrescriptions(orgId, branchName);
    }
  }

  render() {
    const { user } = this.props.auth;
    const { email } = this.props.mqtt;
    if (localStorage.branch === undefined) {
      localStorage.branch = "" + user.branch[0];
    }
    let branches;
    if (user.branch) {
      branches = user.branch.map(branch => (
        <div key={branch}>
          <DropdownItem>
            <span
              className="text-capitalize"
              onClick={() => this.changeBranch(branch)}
            >
              {branch}
            </span>
          </DropdownItem>
          <DropdownItem divider />
        </div>
      ));
    } else branches = " ";
    return (
      <Navbar fixed="top" expand="lg" className="nav-background">
        <div className="logo clearfix">
          <NavbarBrand href="/dashboard" className="logo-text float-left">
            <img
              src={require("../../assets/img/logo_login.png")}
              alt=""
              style={{
                width: "35px",
                height: "35px"
              }}
            />
          </NavbarBrand>
        </div>
        <NavbarToggler onClick={this.toggle} className="navbar-dark" />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            {email === user.sub && (
              <NavItem>
                <div id="ex4" className="nav-link nav-link-color">
                  <span className="p1 fa-stack fa-lg has-badge" data-count="1">
                    <i className="fas fa-phone" data-count="4b" />
                  </span>
                </div>
              </NavItem>
            )}
            {this.props.mqtt.data_update && !this.props.mqtt.initial_load ? (
              <Spinner name="line-scale-pulse-out" color="white" />
            ) : (
              <div className="refresh">
                <Popup
                  content="Refresh Prescription Data"
                  trigger={
                    <i
                      className="fas fa-sync-alt fa-1x white"
                      onClick={() => {
                        this.updateData();
                      }}
                    ></i>
                  }
                />
              </div>
            )}

            {user.branch ? (
              user.role != 'Pharmacist' && user.branch.length > 1 ? (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret className="nav-link-color">
                    <i className="fas fa-code-branch fa-lg mr-1" />
                    <span className="text-capitalize">
                      {localStorage.branch}
                    </span>
                  </DropdownToggle>

                  <DropdownMenu right>{branches}</DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                <li className="dropdown nav-item">
                  <div className="nav-link nav-link-color">
                    <i className="fas fa-code-branch fa-lg mr-1" />
                    <span className="text-capitalize">
                      {localStorage.branch}
                    </span>
                  </div>
                </li>
              )
            ) : ''}

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="nav-link-color">
                <Avatar name={user.sub} size="30" round={true} />
                <span className="text-capitalize p-2">{user.sub}</span>
              </DropdownToggle>
              <DropdownMenu right>
                {/*<DropdownItem tag={Link} to="" className="py-1">*/}
                {/*<i className="fas fa-user-edit icon-color mr-2"/>*/}
                {/*<span>My Profile</span>*/}
                {/*</DropdownItem>*/}
                {/*<DropdownItem divider/>*/}
                {/*<DropdownItem tag={Link} to="/dashboard/admin" className="py-1">*/}
                {/*<i className="fas fa-cogs icon-color mr-2"/>*/}
                {/*<span>User Management</span>*/}
                {/*</DropdownItem>*/}
                {/*<DropdownItem divider/>*/}
                <DropdownItem
                  tag={Link}
                  to="/dashboard2"
                  className="py-1"
                // onClick={this.logout.bind(this)}
                >

                  {user.isAdmin && (<span><i class="fas fa-sliders-h icon-color mr-2"></i>Admin Settings</span>)}
                </DropdownItem>
                <DropdownItem
                  tag={Link}
                  to=""
                  className="py-1"
                  onClick={this.logout.bind(this)}
                >
                  <i className="fas fa-power-off icon-color mr-2" />
                  <span>Logout</span>
                </DropdownItem>


              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

NavigationBar.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  mqttConnectionInit: PropTypes.func.isRequired,
  getPrescriptions: PropTypes.func.isRequired,
  getPrescriptionByStatus: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ auth: state.auth, mqtt: state.mqtt });

export default connect(mapStateToProps, {
  mqttConnectionInit,
  logoutUser,
  getPrescriptions,
  getPrescriptionByStatus,
})(NavigationBar);
